module.exports = __webpack_public_path__ + "static/Clarity-82cf3f6839250685c433b8b56709b1d1.jpg";